import { getDaffyFetchOptions } from '~/helpers/api';
import { routes } from '~/helpers/routes';
import type { ResourceType } from '../types';

const AWS_REGION = 'us-east-1';
const AWS_SIG_V4_HEADER_KEY = 'X-Alloy-Provisioning-Sign-V4';
const JWT_HEADER_KEY = 'X-ALLOY-PROVISIONING-JWT';
const TOKEN_SERVICE = 'lambda';

// ============================================================
//         CELL HELPER
// ============================================================
export const getCurrentCell = (alloyEnvironment: string) => alloyEnvironment.replace('kube', '');


// ============================================================
//         JWT TOKEN
// ============================================================

/**
 * fetch JWT token which is used to seamlessly navigate between cells
 */
export const fetchJwtToken = async (jwtType: string = 'provisioning') => {
  const response = await fetch(
    routes.v3.admin.jwt_auth(jwtType),
    getDaffyFetchOptions({
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({}),
    }),
  );

  return response?.headers.get(JWT_HEADER_KEY);
};

// ============================================================
//         AWS TOKEN
// ============================================================

type FetchAwsTokenParams = {
  resource: ResourceType;
  payload?: Object | undefined;
  // TODO - Ideal solution is the below should all come from the backend in a JWT
  email: string;
  provisioningLambdaUrl: string;
  isAfefParentAgentRequest?: boolean | undefined;
  alloyEnvironment?: string;
  awsRegion?: string;
};

/**
 * Request made to the Provisioning service lambda requires an aws sign v4 token attach on header.
 *
 * fetchAwsToken generates a token base on request method, body, data & headers.
 */
export const fetchAwsToken = async ({
  resource,
  alloyEnvironment,
  email,
  isAfefParentAgentRequest,
  provisioningLambdaUrl,
  payload,
  awsRegion,
}: FetchAwsTokenParams): Promise<Record<string, string>> => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      region: awsRegion || AWS_REGION,
      service: TOKEN_SERVICE,
      method: 'POST',
      url: provisioningLambdaUrl,
      data: JSON.stringify({
        ...(resource ? { resource } : {}),
        ...(email ? { email } : {}),
        ...(isAfefParentAgentRequest ? { isAfefParentAgentRequest } : {}),
        ...(alloyEnvironment ? {
          requestCellKey: getCurrentCell(alloyEnvironment),
        } : {}),
        ...(payload ? { ...payload } : {}),
      }),
      headers: JSON.stringify({ 'Content-type': 'application/json' }),
    }),
  };

  const response = await fetch(
    routes.v3.admin.aws_auth_v4,
    getDaffyFetchOptions(requestOptions),
  );

  const cleanedAwsToken = response?.headers.get(AWS_SIG_V4_HEADER_KEY);
  const awsTokenObj = JSON.parse(cleanedAwsToken || '{}');
  return awsTokenObj;
};
